module.exports = __webpack_public_path__ + "img/case1-4.c84ba739.png";